<template>
  <div>
    <!-- begin breadcrumb -->
    <ol class="breadcrumb float-xl-right">
      <li class="breadcrumb-item active">
        <a href="javascript:;">Dashboard</a>
      </li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">
      Dashboard
      <small
        >See the status of your planning in storyboard, stages, steps, space,
        stuff, staff and support service. Adjust until you’re satisfied.</small
      >
    </h1>
    <!-- end page-header -->
    <div class="row">
      <div class="col-xl-3 col-lg-6">
        <div class="card border-0 bg-dark text-white text-truncate mb-3">
          <div class="card-body">
            <div class="mb-3 text-grey">
              <b class="mb-3">SCRIPT STATS</b>
              <span class="ml-2"
                ><i
                  class="fa fa-info-circle"
                  title="Script stats"
                  v-b-popover.hover="'This is a compilation of script stats'"
                ></i
              ></span>
            </div>
            <div class="d-flex mb-2">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-black f-s-8 mr-2"></i>
                Steps started
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ stepsStarted }}
                </div>
              </div>
            </div>
            <div class="d-flex mb-2">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-gray f-s-8 mr-2"></i>
                Steps confirmed
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ activeSteps }}
                </div>
              </div>
            </div>
            <div class="d-flex">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-white f-s-8 mr-2"></i>
                Missing info
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ missingInfo + '/' + stepCount * 4 }}
                </div>
              </div>
            </div>
            <hr class="bg-white-transparent-2 m-t-20 m-b-20" />
            <div class="row align-items-center p-b-1">
              <div class="col-12">
                <div class="m-b-2 text-truncate">Planning process</div>
                <div class="d-flex align-items-center m-b-2">
                  <div class="flex-grow-1">
                    <div
                      class="
                        progress progress-xs
                        rounded-corner
                        bg-white-transparent-1
                      "
                    >
                      <div
                        class="progress-bar progress-bar-striped bg-yellow"
                        :style="'width: ' + planningProgress + '%'"
                      ></div>
                    </div>
                  </div>
                  <div class="ml-2 f-s-11 width-30 text-center">
                    {{ planningProgress }}%
                  </div>
                </div>
                <div class="text-grey f-s-11 m-b-15 text-truncate">
                  Almost there
                </div>
                <url-button
                  label="Script"
                  :url="'/script'"
                  class="btn-yellow m-t-10"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-lg-6">
        <div class="card border-0 bg-dark text-white text-truncate mb-3">
          <div class="card-body">
            <div class="mb-3 text-grey">
              <b class="mb-3">STORYBOARDS</b>
              <span class="ml-2"
                ><i
                  class="fa fa-info-circle"
                  title="Storyboards"
                  v-b-popover.hover="
                    'This is a compilation of storyboard stats'
                  "
                ></i
              ></span>
            </div>
            <div class="d-flex mb-2">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-black f-s-8 mr-2"></i>
                Total
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ storyboardCount }}
                </div>
              </div>
            </div>
            <div class="d-flex mb-2">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-gray f-s-8 mr-2"></i>
                Active
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ activeStoryboards }}
                </div>
              </div>
            </div>
            <div class="d-flex">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-white f-s-8 mr-2"></i>
                Stages on average
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ stagesInStoryboard }}
                </div>
              </div>
            </div>
            <hr class="bg-white-transparent-2 m-t-20 m-b-20" />
            <div class="row align-items-center p-b-1">
              <div class="col-12">
                <div class="m-b-2 text-truncate">Planning progress</div>
                <div class="d-flex align-items-center m-b-2">
                  <div class="flex-grow-1">
                    <div
                      class="
                        progress progress-xs
                        rounded-corner
                        bg-white-transparent-1
                      "
                    >
                      <div
                        class="progress-bar progress-bar-striped bg-yellow"
                        :style="'width: ' + storyboardProgress + '%'"
                      ></div>
                    </div>
                  </div>
                  <div class="ml-2 f-s-11 width-30 text-center">
                    {{ storyboardProgress }}%
                  </div>
                </div>
                <div class="text-grey f-s-11 m-b-15 text-truncate">
                  Almost there
                </div>
                <url-button
                  label="Storyboards"
                  :url="'/storyboard/search/storyboards'"
                  class="btn-yellow m-t-10"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-lg-6">
        <div class="card border-0 bg-dark text-white text-truncate mb-3">
          <div class="card-body">
            <div class="mb-3 text-grey">
              <b class="mb-3">STAGES</b>
              <span class="ml-2"
                ><i
                  class="fa fa-info-circle"
                  title="Stages"
                  v-b-popover.hover="'This is a compilation of stage stats'"
                ></i
              ></span>
            </div>
            <div class="d-flex mb-2">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-black f-s-8 mr-2"></i>
                Total
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ stageCount }}
                </div>
              </div>
            </div>
            <div class="d-flex mb-2">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-gray f-s-8 mr-2"></i>
                Active
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ activeStages }}
                </div>
              </div>
            </div>
            <div class="d-flex">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-white f-s-8 mr-2"></i>
                Steps on average
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ stepsInStage }}
                </div>
              </div>
            </div>
            <hr class="bg-white-transparent-2 m-t-20 m-b-20" />
            <div class="row align-items-center p-b-1">
              <div class="col-12">
                <div class="m-b-2 text-truncate">Planning progress</div>
                <div class="d-flex align-items-center m-b-2">
                  <div class="flex-grow-1">
                    <div
                      class="
                        progress progress-xs
                        rounded-corner
                        bg-white-transparent-1
                      "
                    >
                      <div
                        class="progress-bar progress-bar-striped bg-yellow"
                        :style="'width: ' + stageProgress + '%'"
                      ></div>
                    </div>
                  </div>
                  <div class="ml-2 f-s-11 width-30 text-center">
                    {{ stageProgress }}%
                  </div>
                </div>
                <div class="text-grey f-s-11 m-b-15 text-truncate">
                  Almost there
                </div>
                <url-button
                  label="Stages"
                  :url="'/storyboard/search/stages'"
                  class="btn-yellow m-t-10"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-lg-6">
        <div class="card border-0 bg-dark text-white text-truncate mb-3">
          <div class="card-body">
            <div class="mb-3 text-grey">
              <b class="mb-3">STEPS</b>
              <span class="ml-2"
                ><i
                  class="fa fa-info-circle"
                  title="Steps"
                  v-b-popover.hover="'This is a compilation of step stats'"
                ></i
              ></span>
            </div>
            <div class="d-flex mb-2">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-black f-s-8 mr-2"></i>
                Total
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ stepCount }}
                </div>
              </div>
            </div>
            <div class="d-flex mb-2">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-gray f-s-8 mr-2"></i>
                Active
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ activeSteps }}
                </div>
              </div>
            </div>
            <div class="d-flex">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-dark f-s-8 mr-2"></i>
                &shy;
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600"></div>
              </div>
            </div>
            <hr class="bg-white-transparent-2 m-t-20 m-b-20" />
            <div class="row align-items-center p-b-1">
              <div class="col-12">
                <div class="m-b-2 text-truncate">Planning progress</div>
                <div class="d-flex align-items-center m-b-2">
                  <div class="flex-grow-1">
                    <div
                      class="
                        progress progress-xs
                        rounded-corner
                        bg-white-transparent-1
                      "
                    >
                      <div
                        class="progress-bar progress-bar-striped bg-yellow"
                        :style="'width: ' + stepProgress + '%'"
                      ></div>
                    </div>
                  </div>
                  <div class="ml-2 f-s-11 width-30 text-center">
                    {{ stepProgress }}%
                  </div>
                </div>
                <div class="text-grey f-s-11 m-b-15 text-truncate">
                  Almost there
                </div>
                <url-button
                  label="Steps"
                  :url="'/storyboard/search/steps'"
                  class="btn-yellow m-t-10"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-3 col-lg-6">
        <div class="card border-0 bg-dark text-white text-truncate mb-3">
          <div class="card-body">
            <div class="mb-3 text-grey">
              <b class="mb-3">SPACE STATS</b>
              <span class="ml-2"
                ><i
                  class="fa fa-info-circle"
                  title="Space stats"
                  v-b-popover.hover="'This is a compilation of space stats'"
                ></i
              ></span>
            </div>
            <div class="d-flex mb-2">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-indigo f-s-8 mr-2"></i>
                Space items
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ spaceCount }}
                </div>
              </div>
            </div>
            <div class="d-flex mb-2">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-purple f-s-8 mr-2"></i>
                Areas
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">{{ areas }}</div>
              </div>
            </div>
            <div class="d-flex">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-pink f-s-8 mr-2"></i>
                Venues
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">{{ venues }}</div>
              </div>
            </div>
            <hr class="bg-white-transparent-2 m-t-20 m-b-20" />
            <div class="d-flex mb-2">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-black f-s-8 mr-2"></i>
                Available
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ availableSpaces }}
                </div>
              </div>
            </div>
            <div class="d-flex mb-2">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-gray f-s-8 mr-2"></i>
                Active
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ activeSpaces }}
                </div>
              </div>
            </div>
            <div class="d-flex mb-2">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-white f-s-8 mr-2"></i>
                Balance
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ balanceSpaces }}
                </div>
              </div>
            </div>
            <url-button
              label="Search"
              :url="'/eventbank/space'"
              class="btn-yellow m-t-10"
            />
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-lg-6">
        <div class="card border-0 bg-dark text-white text-truncate mb-3">
          <div class="card-body">
            <div class="mb-3 text-grey">
              <b class="mb-3">STUFF STATS</b>
              <span class="ml-2"
                ><i
                  class="fa fa-info-circle"
                  title="Stuff stats"
                  v-b-popover.hover="'This is a compilation of stuff stats'"
                ></i
              ></span>
            </div>
            <div class="d-flex mb-2">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-blue f-s-8 mr-2"></i>
                Items
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ stuffCount }}
                </div>
              </div>
            </div>
            <div class="d-flex mb-2">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-aqua f-s-8 mr-2"></i>
                Subcategories
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ subcategories }}
                </div>
              </div>
            </div>
            <div class="d-flex">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-teal f-s-8 mr-2"></i>
                Categories
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ stuffCategories }}
                </div>
              </div>
            </div>
            <hr class="bg-white-transparent-2 m-t-20 m-b-20" />
            <div class="d-flex mb-2">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-black f-s-8 mr-2"></i>
                Available
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 pl-2 f-w-600">
                  {{ availableStuffPcs + ' pcs' }}
                </div>
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ availableStuffM + ' m' }}
                </div>
              </div>
            </div>
            <div class="d-flex mb-2">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-gray f-s-8 mr-2"></i>
                Active
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 pl-2 f-w-600">
                  {{ activeStuffPcs + ' pcs' }}
                </div>
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ activeStuffM + ' m' }}
                </div>
              </div>
            </div>
            <div class="d-flex mb-2">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-white f-s-8 mr-2"></i>
                Balance
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 pl-2 f-w-600">
                  {{ balanceStuffPcs + ' pcs' }}
                </div>
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ balanceStuffM + ' m' }}
                </div>
              </div>
            </div>
            <url-button
              label="Search"
              :url="'/eventbank/stuff'"
              class="btn-yellow m-t-10"
            />
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-lg-6">
        <div class="card border-0 bg-dark text-white text-truncate mb-3">
          <div class="card-body">
            <div class="mb-3 text-grey">
              <b class="mb-3">STAFF STATS</b>
              <span class="ml-2"
                ><i
                  class="fa fa-info-circle"
                  title="Staff stats"
                  v-b-popover.hover="'This is a compilation of staff stats'"
                ></i
              ></span>
            </div>
            <div class="d-flex mb-2">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-green f-s-8 mr-2"></i>
                Staff
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ staffCount }}
                </div>
              </div>
            </div>
            <div class="d-flex mb-2">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-lime f-s-8 mr-2"></i>
                Teams
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">{{ teams }}</div>
              </div>
            </div>
            <div class="d-flex">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-yellow f-s-8 mr-2"></i>
                Groups
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">{{ groups }}</div>
              </div>
            </div>
            <hr class="bg-white-transparent-2 m-t-20 m-b-20" />
            <div class="d-flex mb-2">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-black f-s-8 mr-2"></i>
                Available
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ availableStaff }}
                </div>
              </div>
            </div>
            <div class="d-flex mb-2">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-gray f-s-8 mr-2"></i>
                Active
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ activeStaff }}
                </div>
              </div>
            </div>
            <div class="d-flex mb-2">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-white f-s-8 mr-2"></i>
                Balance
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ balanceStaff }}
                </div>
              </div>
            </div>
            <url-button
              label="Search"
              :url="'/eventbank/staff'"
              class="btn-yellow m-t-10"
            />
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-lg-6">
        <div class="card border-0 bg-dark text-white text-truncate mb-3">
          <div class="card-body">
            <div class="mb-3 text-grey">
              <b class="mb-3">SERVICE STATS</b>
              <span class="ml-2"
                ><i
                  class="fa fa-info-circle"
                  title="Service stats"
                  v-b-popover.hover="'This is a compilation of service stats'"
                ></i
              ></span>
            </div>
            <div class="d-flex mb-2">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-red f-s-8 mr-2"></i>
                Service providers
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ serviceCount }}
                </div>
              </div>
            </div>
            <div class="d-flex mb-2">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-orange f-s-8 mr-2"></i>
                Service areas
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ serviceAreas }}
                </div>
              </div>
            </div>
            <div class="d-flex">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-yellow f-s-8 mr-2"></i>
                Service Categories
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ serviceCategories }}
                </div>
              </div>
            </div>
            <hr class="bg-white-transparent-2 m-t-20 m-b-20" />
            <div class="d-flex mb-2">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-black f-s-8 mr-2"></i>
                Available
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ availableServices }}
                </div>
              </div>
            </div>
            <div class="d-flex mb-2">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-gray f-s-8 mr-2"></i>
                Active
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ activeServices }}
                </div>
              </div>
            </div>
            <div class="d-flex mb-2">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-white f-s-8 mr-2"></i>
                Balance
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ balanceServices }}
                </div>
              </div>
            </div>
            <url-button
              label="Search"
              :url="'/eventbank/service'"
              class="btn-yellow m-t-10"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-8 col-lg-6 mb-3">
        <b-card no-body>
          <b-tabs
            justified
            nav-wrapper-class="nav-tabs-inverse"
            nav-class="nav-tabs-inverse"
          >
            <b-tab active>
              <template slot="title">
                <span class="d-sm-none"
                  >Space
                  <b-badge v-if="spaceIssues.length" variant="danger">{{
                    spaceIssues.length
                  }}</b-badge></span
                >
                <span class="d-sm-block d-none"
                  >Space
                  <b-badge v-if="spaceIssues.length" variant="danger">{{
                    spaceIssues.length
                  }}</b-badge></span
                >
              </template>
              <vue-custom-scrollbar class="overflow-auto height-md">
                <ul
                  class="
                    media-list media-list-with-divider media-messaging
                    mt-2
                    mb-2
                  "
                >
                  <li
                    class="media media-sm"
                    v-for="(spaceIssue, index) in spaceIssues"
                    :key="index"
                  >
                    <div class="media-body">
                      <h5 class="media-heading">{{ spaceIssue.errorCode }}</h5>
                      <p>{{ spaceIssue.message }}</p>
                      <url-button
                        label="Go to"
                        :url="`/eventbank/space/items/` + spaceIssue.itemId"
                        class="btn-yellow pull-right"
                      />
                    </div>
                  </li>
                  <li v-if="!spaceIssues.length" class="media media-sm">
                    <div class="media-body">
                      <p>No issues</p>
                    </div>
                  </li>
                </ul>
              </vue-custom-scrollbar>
            </b-tab>
            <b-tab>
              <template slot="title">
                <span class="d-sm-none"
                  >Stuff
                  <b-badge v-if="stuffIssues.length" variant="danger">{{
                    stuffIssues.length
                  }}</b-badge></span
                >
                <span class="d-sm-block d-none"
                  >Stuff
                  <b-badge v-if="stuffIssues.length" variant="danger">{{
                    stuffIssues.length
                  }}</b-badge></span
                >
              </template>
              <vue-custom-scrollbar class="overflow-auto height-md">
                <ul
                  class="
                    media-list media-list-with-divider media-messaging
                    mt-2
                    mb-2
                  "
                >
                  <li
                    class="media media-sm"
                    v-for="(stuffIssue, index) in stuffIssues"
                    :key="index"
                  >
                    <div class="media-body">
                      <h5 class="media-heading">{{ stuffIssue.errorCode }}</h5>
                      <p>{{ stuffIssue.message }}</p>
                      <url-button
                        label="Go to"
                        :url="`/eventbank/stuff/items/` + stuffIssue.itemId"
                        class="btn-yellow pull-right"
                      />
                    </div>
                  </li>
                  <li v-if="!stuffIssues.length" class="media media-sm">
                    <div class="media-body">
                      <p>No issues</p>
                    </div>
                  </li>
                </ul>
              </vue-custom-scrollbar>
            </b-tab>
            <b-tab>
              <template slot="title">
                <span class="d-sm-none"
                  >Staff
                  <b-badge v-if="staffIssues.length" variant="danger">{{
                    staffIssues.length
                  }}</b-badge></span
                >
                <span class="d-sm-block d-none"
                  >Staff
                  <b-badge v-if="staffIssues.length" variant="danger">{{
                    staffIssues.length
                  }}</b-badge></span
                >
              </template>
              <vue-custom-scrollbar class="overflow-auto height-md">
                <ul
                  class="
                    media-list media-list-with-divider media-messaging
                    mt-2
                    mb-2
                  "
                >
                  <li
                    class="media media-sm"
                    v-for="(staffIssue, index) in staffIssues"
                    :key="index"
                  >
                    <div class="media-body">
                      <h5 class="media-heading">{{ staffIssue.errorCode }}</h5>
                      <p>{{ staffIssue.message }}</p>
                      <url-button
                        label="Go to"
                        :url="`/eventbank/staff/items/` + staffIssue.itemId"
                        class="btn-yellow pull-right"
                      />
                    </div>
                  </li>
                  <li v-if="!staffIssues.length" class="media media-sm">
                    <div class="media-body">
                      <p>No issues</p>
                    </div>
                  </li>
                </ul>
              </vue-custom-scrollbar>
            </b-tab>
            <b-tab>
              <template slot="title">
                <span class="d-sm-none"
                  >Service
                  <b-badge v-if="serviceIssues.length" variant="danger">{{
                    serviceIssues.length
                  }}</b-badge></span
                >
                <span class="d-sm-block d-none"
                  >Service
                  <b-badge v-if="serviceIssues.length" variant="danger">{{
                    serviceIssues.length
                  }}</b-badge></span
                >
              </template>
              <vue-custom-scrollbar class="overflow-auto height-md">
                <ul
                  class="
                    media-list media-list-with-divider media-messaging
                    mt-2
                    mb-2
                  "
                >
                  <li
                    class="media media-sm"
                    v-for="(serviceIssue, index) in serviceIssues"
                    :key="index"
                  >
                    <div class="media-body">
                      <h5 class="media-heading">
                        {{ serviceIssue.errorCode }}
                      </h5>
                      <p>{{ serviceIssue.message }}</p>
                      <url-button
                        label="Go to"
                        :url="`/eventbank/service/items/` + serviceIssue.itemId"
                        class="btn-yellow pull-right"
                      />
                    </div>
                  </li>
                  <li v-if="!serviceIssues.length" class="media media-sm">
                    <div class="media-body">
                      <p>No issues</p>
                    </div>
                  </li>
                </ul>
              </vue-custom-scrollbar>
            </b-tab>
            <b-tab>
              <template slot="title">
                <span class="d-sm-none"
                  >Storyboard
                  <b-badge v-if="storyboardIssues.length" variant="danger">{{
                    storyboardIssues.length
                  }}</b-badge></span
                >
                <span class="d-sm-block d-none"
                  >Storyboard
                  <b-badge v-if="storyboardIssues.length" variant="danger">{{
                    storyboardIssues.length
                  }}</b-badge></span
                >
              </template>
              <vue-custom-scrollbar class="overflow-auto height-md">
                <ul
                  class="
                    media-list media-list-with-divider media-messaging
                    mt-2
                    mb-2
                  "
                >
                  <li
                    class="media media-sm"
                    v-for="(storyboardIssue, index) in storyboardIssues"
                    :key="index"
                  >
                    <div class="media-body">
                      <h5 class="media-heading">
                        {{ storyboardIssue.errorCode }}
                      </h5>
                      <p>{{ storyboardIssue.message }}</p>
                      <url-button
                        label="Go to"
                        :url="`/storyboard/` + storyboardIssue.storyboardId"
                        class="btn-yellow pull-right"
                      />
                    </div>
                  </li>
                  <li v-if="!storyboardIssues.length" class="media media-sm">
                    <div class="media-body">
                      <p>No issues</p>
                    </div>
                  </li>
                </ul>
              </vue-custom-scrollbar>
            </b-tab>
            <b-tab>
              <template slot="title">
                <span class="d-sm-none"
                  >Stage
                  <b-badge v-if="stageIssues.length" variant="danger">{{
                    stageIssues.length
                  }}</b-badge></span
                >
                <span class="d-sm-block d-none"
                  >Stage
                  <b-badge v-if="stageIssues.length" variant="danger">{{
                    stageIssues.length
                  }}</b-badge></span
                >
              </template>
              <vue-custom-scrollbar class="overflow-auto height-md">
                <ul
                  class="
                    media-list media-list-with-divider media-messaging
                    mt-2
                    mb-2
                  "
                >
                  <li
                    class="media media-sm"
                    v-for="(stageIssue, index) in stageIssues"
                    :key="index"
                  >
                    <div class="media-body">
                      <h5 class="media-heading">{{ stageIssue.errorCode }}</h5>
                      <p>{{ stageIssue.message }}</p>
                      <url-button
                        label="Go to"
                        :url="`/storyboard/null/stage/` + stageIssue.stageId"
                        class="btn-yellow pull-right"
                      />
                    </div>
                  </li>
                  <li v-if="!stageIssues.length" class="media media-sm">
                    <div class="media-body">
                      <p>No issues</p>
                    </div>
                  </li>
                </ul>
              </vue-custom-scrollbar>
            </b-tab>
            <b-tab>
              <template slot="title">
                <span class="d-sm-none"
                  >Step
                  <b-badge v-if="stepIssues.length" variant="danger">{{
                    stepIssues.length
                  }}</b-badge></span
                >
                <span class="d-sm-block d-none"
                  >Step
                  <b-badge v-if="stepIssues.length" variant="danger">{{
                    stepIssues.length
                  }}</b-badge></span
                >
              </template>
              <vue-custom-scrollbar class="overflow-auto height-md">
                <ul
                  class="
                    media-list media-list-with-divider media-messaging
                    mt-2
                    mb-2
                  "
                >
                  <li
                    class="media media-sm"
                    v-for="(stepIssue, index) in stepIssues"
                    :key="index"
                  >
                    <div class="media-body">
                      <h5 class="media-heading">{{ stepIssue.errorCode }}</h5>
                      <p>{{ stepIssue.message }}</p>
                      <url-button
                        label="Go to"
                        :url="`/script/space/` + stepIssue.stepId"
                        class="btn-yellow pull-right"
                      />
                    </div>
                  </li>
                  <li v-if="!stepIssues.length" class="media media-sm">
                    <div class="media-body">
                      <p>No issues</p>
                    </div>
                  </li>
                </ul>
              </vue-custom-scrollbar>
            </b-tab>
          </b-tabs>
        </b-card>
      </div>
      <div class="col-xl-4 col-lg-6">
        <panel title="Noteboard" no-button="true">
          <vue-custom-scrollbar class="height-sm">
            <ul class="media-list media-list-with-divider media-messaging">
              <li class="media media-sm" v-for="note in notes" :key="note.id">
                <div class="media-body">
                  <h5 class="media-heading">
                    {{ note.createdAt | formatTime }}
                  </h5>
                  <p>{{ note.content }}</p>
                  <b-button
                    class="btn btn-danger pull-right"
                    @click="deleteModal(note.id)"
                  >
                    Delete
                  </b-button>
                </div>
              </li>
              <li v-if="!notes.length" class="media media-sm">
                <div class="media-body">
                  <p>No notes</p>
                </div>
              </li>
            </ul>
          </vue-custom-scrollbar>
          <template slot="footer">
            <form>
              <div class="input-group">
                <input
                  v-model="noteContent"
                  type="text"
                  class="form-control bg-light"
                  placeholder="Enter message"
                />
                <span class="input-group-append">
                  <button
                    @click="createNoteCall()"
                    class="btn btn-primary pull-right"
                    type="button"
                  >
                    <i class="fa fa-pencil-alt"></i>
                  </button>
                </span>
              </div>
            </form>
          </template>
        </panel>
      </div>
    </div>
    <b-modal
      ref="modalAlert"
      centered
      title="Delete note"
      cancel-variant="white"
      ok-variant="danger"
      ok-title="Delete"
      v-on:ok="deleteNoteCall"
    >
      <div class="alert alert-danger m-b-0">
        <h5><i class="fa fa-info-circle"></i>Delete</h5>
        <p>Are you sure you want to delete the note?</p>
      </div>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState, mapActions } from 'vuex'
import UrlButton from '../components/buttons/UrlButton'

export default {
  name: 'Dashboard',
  components: {
    UrlButton
  },
  data() {
    return {
      bankLoaded: false,
      scriptLoaded: false,
      planningProgress: 0,
      stepsStarted: 0,
      missingInfo: 0,
      serviceCount: 0,
      serviceAreas: 0,
      serviceCategories: 0,
      spaceCount: 0,
      areas: 0,
      venues: 0,
      staffCount: 0,
      teams: 0,
      groups: 0,
      stuffCount: 0,
      subcategories: 0,
      stuffCategories: 0,
      storyboardCount: 0,
      activeStoryboards: 0,
      stagesInStoryboard: 0,
      storyboardProgress: 0,
      stageCount: 0,
      activeStages: 0,
      stepsInStage: 0,
      stageProgress: 0,
      stepCount: 0,
      activeSteps: 0,
      stepProgress: 0,
      availableSpaces: 0,
      availableStuffPcs: 0,
      availableStuffM: 0,
      availableStaff: 0,
      availableServices: 0,
      activeSpaces: 0,
      activeStuffPcs: 0,
      activeStuffM: 0,
      activeStaff: 0,
      activeServices: 0,
      balanceSpaces: 0,
      balanceStuffPcs: 0,
      balanceStuffM: 0,
      balanceStaff: 0,
      balanceServices: 0,
      serviceIssues: [],
      spaceIssues: [],
      staffIssues: [],
      stuffIssues: [],
      storyboardIssues: [],
      stageIssues: [],
      stepIssues: [],
      noteContent: '',
      currentNoteId: 0
    }
  },
  filters: {
    formatTime(dateString) {
      let date = new Date(dateString)
      return moment(date).format('YYYY/MM/DD hh:mm')
    }
  },
  computed: {
    ...mapState('item', ['items']),
    ...mapState('category', ['categories']),
    ...mapState('storyboard', ['storyboards']),
    ...mapState('stage', ['stages']),
    ...mapState('step', ['steps']),
    ...mapState('scriptitem', ['scriptItems']),
    ...mapState('event', ['activeEvent']),
    ...mapState('note', ['notes'])
  },
  methods: {
    ...mapActions('item', ['getItems']),
    ...mapActions('category', ['getCategories']),
    ...mapActions('storyboard', ['getStoryboards']),
    ...mapActions('stage', ['getStages']),
    ...mapActions('step', ['getSteps']),
    ...mapActions('scriptitem', ['getScriptItems']),
    ...mapActions('note', ['getNotes', 'createNote', 'deleteNote']),
    getScriptCounts() {
      let totalProgress = 0
      let stepsCounted = false
      let stageId = 0
      let stepId = 0
      this.storyboards.forEach((storyboard) => {
        if (storyboard.event == this.activeEvent.id) {
          if (!storyboard.description) {
            this.storyboardIssues.push({
              errorCode: 'Missing info',
              message: storyboard.name + ' is missing a description.',
              storyboardId: storyboard.id
            })
          }
          this.storyboardCount++
          if (!storyboard.stages.length) {
            this.storyboardIssues.push({
              errorCode: 'Empty storyboard',
              message: storyboard.name + ' has no stages in it.',
              storyboardId: storyboard.id
            })
          }
          storyboard.stages.forEach((storyboardStage) => {
            let currentActiveStages = 0
            this.stages.forEach((stage) => {
              if (stage.id > stageId) {
                if (!stage.description) {
                  this.stageIssues.push({
                    errorCode: 'Missing info',
                    message: stage.name + ' is missing a description.',
                    storyboardId: stage.id
                  })
                }
                if (!stage.steps.length) {
                  this.stageIssues.push({
                    errorCode: 'Empty stage',
                    message: stage.name + ' has no steps in it.',
                    stageId: stage.id
                  })
                }
                stageId = stage.id
              }
              if (stage.id == storyboardStage.id) {
                this.stageCount++
                let currentActiveSteps = 0
                this.steps.forEach((step) => {
                  if (step.id > stepId) {
                    if (!step.description) {
                      this.stepIssues.push({
                        errorCode: 'Missing info',
                        message: step.name + ' is missing a description.',
                        storyboardId: step.id
                      })
                    }
                    stepId = step.id
                  }

                  let currentErrors = []
                  if (!stepsCounted) {
                    this.stepCount++
                  }
                  if (step.stage == stage.id) {
                    let currentStepProgress = 0
                    if (step.service) {
                      currentStepProgress += 25
                    } else {
                      this.missingInfo++
                      currentErrors.push({ type: 'service' })
                    }
                    if (step.space) {
                      currentStepProgress += 25
                    } else {
                      this.missingInfo++
                      currentErrors.push({ type: 'space' })
                    }
                    if (step.staff) {
                      currentStepProgress += 25
                    } else {
                      this.missingInfo++
                      currentErrors.push({ type: 'staff' })
                    }
                    if (step.stuff) {
                      currentStepProgress += 25
                    } else {
                      this.missingInfo++
                      currentErrors.push({ type: 'stuff' })
                    }

                    if (currentStepProgress == 0) {
                      this.stepIssues.push({
                        errorCode: 'Empty step',
                        message: step.name + ' has no items in it.',
                        stepId: step.id
                      })
                    } else if (currentStepProgress == 100) {
                      this.stepsStarted++
                      this.activeSteps++
                      currentActiveSteps++
                    } else {
                      this.stepsStarted++
                      let errorString = ''
                      for (let i = 0; i < currentErrors.length; i++) {
                        if (i < currentErrors.length - 2) {
                          errorString += currentErrors[i].type + ', '
                        } else if (i == currentErrors.length - 2) {
                          errorString += currentErrors[i].type + ' & '
                        } else {
                          errorString += currentErrors[i].type + '.'
                        }
                      }
                      this.stepIssues.push({
                        errorCode: 'Unfinished step',
                        message:
                          step.name +
                          ' is missing items or confirmations from ' +
                          errorString,
                        stepId: step.id
                      })
                    }
                    totalProgress += currentStepProgress
                  }
                })
                stepsCounted = true
                if (
                  currentActiveSteps == stage.steps.length &&
                  currentActiveSteps != 0
                ) {
                  this.activeStages++
                  currentActiveStages++
                }
              }
            })
            if (
              currentActiveStages == storyboard.stages.length &&
              currentActiveStages != 0
            ) {
              this.activeStoryboards++
            }
          })
        }
        this.stagesInStoryboard = (
          this.stageCount / this.storyboardCount
        ).toFixed(1)
        this.storyboardProgress = (
          (this.activeStoryboards / this.storyboardCount) *
          100
        ).toFixed(1)
        this.stepsInStage = (this.stepCount / this.stageCount).toFixed(1)
        this.stepProgress = ((this.activeSteps / this.stepCount) * 100).toFixed(
          1
        )
        this.planningProgress = (totalProgress / this.stepCount).toFixed(1)
        this.stageProgress = (
          (this.activeStages / this.stageCount) *
          100
        ).toFixed(1)
      })
    },
    getBankCounts() {
      let itemId = 0,
        totalSpaces = 0,
        totalStuffPcs = 0,
        totalStuffM = 0,
        totalStaff = 0,
        totalServices = 0
      this.items.forEach((item) => {
        let currentAmountInUse = 0
        this.scriptItems.forEach((scriptItem) => {
          if (scriptItem.item.id == item.id) {
            currentAmountInUse += scriptItem.amount
            switch (item.type.id) {
              case 1:
                this.activeServices += scriptItem.amount
                if (itemId < item.id) {
                  if (scriptItem.amount > item.amount) {
                    this.serviceIssues.push({
                      errorCode: 'Negative balance',
                      message: item.name + ' has negative balance.',
                      itemId: item.id
                    })
                  }
                  itemId = item.id
                }
                break
              case 2:
                this.activeSpaces += scriptItem.amount
                if (scriptItem.amount > item.amount && itemId < item.id) {
                  this.spaceIssues.push({
                    errorCode: 'Negative balance',
                    message: item.name + ' has negative balance.',
                    itemId: item.id
                  })
                  itemId = item.id
                }
                break
              case 3:
                this.activeStaff += scriptItem.amount
                if (scriptItem.amount > item.amount && itemId < item.id) {
                  this.staffIssues.push({
                    errorCode: 'Negative balance',
                    message: item.name + ' has negative balance.',
                    itemId: item.id
                  })
                  itemId = item.id
                }
                break
              case 4:
                if (item.unit == 'm') {
                  this.activeStuffM += scriptItem.amount
                } else {
                  this.activeStuffPcs += scriptItem.amount
                }
                if (scriptItem.amount > item.amount && itemId < item.id) {
                  this.stuffIssues.push({
                    errorCode: 'Negative balance',
                    message: item.name + ' has negative balance.',
                    itemId: item.id
                  })
                  itemId = item.id
                }
                break
              default:
                break
            }
          }
        })
        let currentItemBalance = item.amount - currentAmountInUse
        if (currentItemBalance > 0) {
          switch (item.type.id) {
            case 1:
              this.availableServices += currentItemBalance
              break
            case 2:
              this.availableSpaces += currentItemBalance
              break
            case 3:
              this.availableStaff += currentItemBalance
              break
            case 4:
              if (item.unit == 'm') {
                this.availableStuffM += currentItemBalance
              } else {
                this.availableStuffPcs += currentItemBalance
              }
              break
          }
        }

        let errorPoints = []
        let errorMessage = ''
        if (!item.description) {
          errorPoints.push({ point: 'a description' })
        }
        if (item.amount == 0) {
          errorPoints.push({ point: 'the amount' })
        }
        if (errorPoints.length) {
          if (errorPoints.length == 1) {
            errorMessage =
              item.name + ' is missing ' + errorPoints[0].point + '.'
          } else {
            errorMessage =
              item.name +
              ' is missing ' +
              errorPoints[0].point +
              ' and ' +
              errorPoints[1].point +
              '.'
          }
        }

        switch (item.type.id) {
          case 1:
            this.serviceCount++
            totalServices += item.amount
            if (!item.category) {
              this.serviceIssues.push({
                errorCode: 'Uncategorized service',
                message: item.name + ' does not belong to any service area.',
                itemId: item.id
              })
            }
            if (errorMessage != '') {
              this.serviceIssues.push({
                errorCode: 'Missing info',
                message: errorMessage,
                itemId: item.id
              })
            }
            break
          case 2:
            this.spaceCount++
            totalSpaces += item.amount
            if (!item.category) {
              this.spaceIssues.push({
                errorCode: 'Uncategorized space',
                message: item.name + ' does not belong to any area.',
                itemId: item.id
              })
            }
            if (errorMessage != '') {
              this.spaceIssues.push({
                errorCode: 'Missing info',
                message: errorMessage,
                itemId: item.id
              })
            }
            break
          case 3:
            this.staffCount++
            totalStaff += item.amount
            if (!item.category) {
              this.staffIssues.push({
                errorCode: 'Uncategorized staff',
                message: item.name + ' does not belong to any team.',
                itemId: item.id
              })
            }
            if (errorMessage != '') {
              this.staffIssues.push({
                errorCode: 'Missing info',
                message: errorMessage,
                itemId: item.id
              })
            }
            break
          case 4:
            this.stuffCount++
            if (item.unit == 'm') {
              totalStuffM += item.amount
            } else {
              totalStuffPcs += item.amount
            }
            if (!item.category) {
              this.stuffIssues.push({
                errorCode: 'Uncategorized stuff',
                message: item.name + ' does not belong to any subcategory.',
                itemId: item.id
              })
            }
            if (errorMessage != '') {
              this.stuffIssues.push({
                errorCode: 'Missing info',
                message: errorMessage,
                itemId: item.id
              })
            }
            break
          default:
            break
        }
      })
      this.balanceServices = totalServices - this.activeServices
      this.balanceSpaces = totalSpaces - this.activeSpaces
      this.balanceStaff = totalStaff - this.activeStaff
      this.balanceStuffM = totalStuffM - this.activeStuffM
      this.balanceStuffPcs = totalStuffPcs - this.activeStuffPcs

      this.categories.forEach((category) => {
        if (category.parent) {
          switch (category.type.id) {
            case 1:
              this.serviceAreas++
              break
            case 2:
              this.areas++
              break
            case 3:
              this.teams++
              break
            case 4:
              this.subcategories++
              break
            default:
              break
          }
        } else {
          switch (category.type.id) {
            case 1:
              this.serviceCategories++
              break
            case 2:
              this.venues++
              break
            case 3:
              this.groups++
              break
            case 4:
              this.stuffCategories++
              break
            default:
              break
          }
        }
      })
    },
    createNoteCall() {
      if (this.noteContent != '') {
        let noteData = JSON.stringify({
          content: this.noteContent,
          eventId: this.activeEvent.id
        })
        this.createNote(noteData)
        this.noteContent = ''
      }
    },
    deleteModal(noteId) {
      this.currentNoteId = noteId
      this.$refs['modalAlert'].show()
    },
    deleteNoteCall() {
      this.deleteNote(this.currentNoteId)
    }
  },
  async mounted() {
    this.getItems(this.activeEvent.id)
    this.getCategories(this.activeEvent.id)
    await this.getStoryboards(this.activeEvent.id)
    await this.getStages(this.activeEvent.id)
    await this.getSteps(this.activeEvent.id)
    this.getScriptItems(this.activeEvent.id)
    this.getNotes(this.activeEvent.id)
  },
  watch: {
    categories: function () {
      if (!this.bankLoaded) {
        this.getBankCounts()
        this.bankLoaded = true
      }
    },
    steps: function () {
      if (!this.scriptLoaded) {
        this.getScriptCounts()
        this.scriptLoaded = true
      }
    }
  }
}
</script>
